import { getFlowConfig } from './getFlowConfig';
export const shouldAddHubInterestStep = () => {
  const flowConfig = getFlowConfig();
  return flowConfig.shouldAddHubInterestStep();
};